import React, { useRef } from "react";
import { Typography, Box, Button, Grid, Chip } from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import "./mobile-phone-contract.css";
import Signature from "../../../../common/signature/signature";

// Define validation schema
const validationSchema = Yup.object().shape({
  agree: Yup.boolean().oneOf([true], "You must accept the terms to proceed."),
});

const MobilePhoneContractAdmission = () => {
  const venoroxSignatureRef = useRef(null);
  const keyWorkerSignatureRef = useRef(null);
  const parentSignatureRef = useRef(null);
  const socialWorkerSignatureRef = useRef(null);

  // Initial form values
  const initialValues = {
    agree: true,
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        const venoroxSignatureData = venoroxSignatureRef.current.getSignatureData();
        const keyWorkerSignatureData = keyWorkerSignatureRef.current.getSignatureData();
        const parentSignatureData = parentSignatureRef.current.getSignatureData();
        const socialWorkerSignatureData = socialWorkerSignatureRef.current.getSignatureData();

        if (!venoroxSignatureData || !keyWorkerSignatureData || !parentSignatureData || !socialWorkerSignatureData) {
          alert("All signatures must be provided.");
          return;
        }

        const formData = {
          ...values,
          venoroxSignature: venoroxSignatureData,
          keyWorkerSignature: keyWorkerSignatureData,
          parentSignature: parentSignatureData,
          socialWorkerSignature: socialWorkerSignatureData,
        };

        console.log("Form data submitted:", formData);
      }}
    >
      {({ handleSubmit }) => (
        <Form onSubmit={handleSubmit} className='contract-container'>
          {/* Header Section */}
          <Box className='header-section-mobile'>
            <Chip label='Admission' />
            <Typography sx={{ fontSize: "22px", fontWeight: "bold", color: "black" }} align='left' mt={1}>
              Mobile Phone Contract
            </Typography>
            <Typography sx={{ fontSize: "14px" }} mt={1} mb={2}>
              An agreement on responsible mobile phone usage, outlining terms, conditions, and consequences for misuse.
            </Typography>
          </Box>

          {/* Contract Content */}
          <Box className='content-section'>
            <Typography sx={{ fontSize: "14px", color: "black" }}>
              <Grid container>
                <Grid> I </Grid>
                <Grid>
                  <Typography sx={{ fontSize: "14px", color: "#FFB700" }}>Venorox</Typography>
                </Grid>
                <Grid> agree to the terms and conditions that follow for the use of my mobile phone.</Grid>
              </Grid>
            </Typography>
            <br />
            <Typography sx={{ fontSize: "14px", color: "black" }}>
              I understand the staff team at Little Norway will not purchase any phone credit for my phone, instead, I
              will purchase credit from my pocket money/reward money.
            </Typography>
            <br />
            <Typography sx={{ fontSize: "14px", color: "black" }}>
              I agree to use the phone responsibly and understand if I do not, my phone may be withheld or only
              available on a supervised basis for an agreed time period.
            </Typography>
            <br />
            <Typography sx={{ fontSize: "14px", color: "black" }}>
              Any misuse of my phone may lead to the phone being withheld for a period or held in a safe place until I
              leave Little Norway.
            </Typography>
          </Box>

          {/* Signature Section */}
          <Box className='signature-grid'>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={5}>
                <Box className='signature-box'>
                  <Signature ref={venoroxSignatureRef} />
                  <Typography align='right'>
                    <Grid container>
                      <Grid>
                        <Typography sx={{ fontSize: "14px", color: "#FFB700" }}>Venorox</Typography>
                      </Grid>
                      <Grid>
                        <Grid>
                          <Typography sx={{ fontSize: "14px" }}>/ Signature</Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid className='clear-signature-button'>
                      <Button variant='outlined' onClick={() => venoroxSignatureRef.current?.clearSignature()}>
                        Clear
                      </Button>
                    </Grid>
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Box className='signature-box'>
                  <Signature ref={keyWorkerSignatureRef} />
                  <Typography align='right'>
                    <Grid container>
                      <Grid>
                        <Typography sx={{ fontSize: "14px", color: "#FFB700" }}>Key Worker</Typography>
                      </Grid>
                      <Grid>
                        <Grid>
                          <Typography sx={{ fontSize: "14px" }}>/ Signature</Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid className='clear-signature-button'>
                      <Button variant='outlined' onClick={() => keyWorkerSignatureRef.current?.clearSignature()}>
                        Clear
                      </Button>
                    </Grid>
                  </Typography>
                </Box>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={5}>
                <Box className='signature-box'>
                  <Signature ref={parentSignatureRef} />
                  <Typography align='right' sx={{ fontSize: "14px", color: "#FFB700" }}>
                    Parent
                  </Typography>
                  <Grid className='clear-signature-button' ml={2}>
                    <Button variant='outlined' onClick={() => parentSignatureRef.current?.clearSignature()}>
                      Clear
                    </Button>
                  </Grid>
                </Box>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Box className='signature-box'>
                  <Signature ref={socialWorkerSignatureRef} />
                  <Typography sx={{ fontSize: "14px" }} align='right'>
                    Social Worker
                  </Typography>
                  <Grid className='clear-signature-button'>
                    <Button variant='outlined' onClick={() => socialWorkerSignatureRef.current?.clearSignature()}>
                      Clear
                    </Button>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Box>

          {/* Submit Button */}
          <Grid item xs={12} mr={1}>
            <div className='submit-button-container'>
              <Button type='submit' variant='contained' color='primary' className='submit-button'>
                Submit
              </Button>
            </div>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default MobilePhoneContractAdmission;
